import globalAxios from 'axios';
export const BASE_PATH = "http://localhost".replace(/\/+$/, "");
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
export class BaseAPI {
    constructor(configuration, basePath = BASE_PATH, axios = globalAxios) {
        var _a;
        this.basePath = basePath;
        this.axios = axios;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = (_a = configuration.basePath) !== null && _a !== void 0 ? _a : basePath;
        }
    }
}
;
export class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        this.field = field;
        this.name = "RequiredError";
    }
}
export const operationServerMap = {};
//# sourceMappingURL=base.js.map